import { Box, Flex, Image, Spinner, Stack, Text, useBreakpointValue } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";

const ContentSelection = ({
    data,
    options,
    setOptions,
    viewSelected,
    setViewSelected,
    developmentData,
    setOptionsTowers,
}) => {
    const [unitSelected, setUnitSelected] = useState(null);
    const [unitSelectedId, setUnitSelectedId] = useState(null);
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    const loadSvg = () => {
        const svg = document.getElementById("svg");
        if (svg) {
            // ==== VALIDATE TO IDENTIFY TYPE OF TAG ON IMAGE SVG ====
            let elementTagName = null;
            const rect = Array.from(svg.getElementsByTagName("rect"));
            const path = Array.from(svg.getElementsByTagName("path"));
            path.forEach((paths) => {
                paths.style.cursor = "pointer";
            });
            elementTagName = rect.concat(path);
            // ==== RUN ARRAY TO SET COLORS DEPENDING OF THE STATUS ====
            for (let ind = 0; ind < data.length; ind++) {
                const elementData = data[ind];
                for (let i = 0; i < elementTagName.length; i++) {
                    const element = elementTagName[i];

                    for (let index = 0; index < elementData?.property_props?.length; index++) {
                        const model = elementData.property_props[index];
                        if (model.property_id === element.id) {
                            if (model.status === "ACTIVE") {
                                element.setAttribute("fill", "#00E503");
                                element.setAttribute("fill-opacity", 0.3);
                            } else if (model.status === "APART") {
                                element.setAttribute("fill", "#FFF300");
                                element.setAttribute("fill-opacity", 0.4);
                            } else {
                                element.setAttribute("fill", "#D80000");
                                element.setAttribute("fill-opacity", 0.3);
                            }
                            break;
                        }
                    }
                }
            }
        }
    };

    useEffect(() => {
        setUnitSelected(null);
        setUnitSelectedId(null);
    }, [viewSelected]);

    useEffect(() => {
        if (data) {
            const options_ = [];
            const towers = [];

            // Filtrar y agrupar los elementos por `map_image_url`
            const groupedByImage = data.reduce((acc, element) => {
                const imageUrl = element?.map_image_url;
                if (imageUrl) {
                    acc[imageUrl] = acc[imageUrl] || [];
                    acc[imageUrl].push(element);
                }
                return acc;
            }, {});

            /* data */ Object.values(groupedByImage).map((element) => {
                if (
                    element[0]?.outter_dimension_props?.filter(
                        (item) => item?.dimension_name?.toUpperCase() == "TOWER"
                    )
                ) {
                    let tower = element[0]?.outter_dimension_props?.filter(
                        (item) => item?.dimension_name?.toUpperCase() == "TOWER"
                    );
                    towers.push(tower[0]?.item_name);
                }
            });
            const towers_ = [...new Set(towers)];
            /* data */ Object.values(groupedByImage).map((element) => {
                if (element[0].map_image_url !== null) {
                    const tower = element[0]?.outter_dimension_props?.filter(
                        (item) => item?.dimension_name?.toUpperCase() == "TOWER"
                    );

                    let concat = `${tower[0]?.item_name && towers_.length > 1 ? tower[0]?.item_name + " / " : ""} ${element[0]?.item_name ? element[0]?.item_name : ""}`;
                    const option = {
                        ...element[0],
                        name_option: concat?.toUpperCase(),
                        tower: tower[0]?.item_name,
                    };
                    options_.push(option);
                }
            });
            setOptions(options_);
            setOptionsTowers(towers_?.sort((a, b) => a.localeCompare(b)));
            if (!viewSelected) setViewSelected(options_[0]);
        }
    }, [data]);

    const handleSelect = (e) => {
        const id = e.target.id;
        const depa = document.getElementById(id);
        const depaColor = depa.getAttribute("fill");
        let flag = true;

        if (id.length >= 15) {
            if (depaColor !== "#D80000" && depaColor !== "#FFF300" && !depaColor.includes("url")) {
                // ==== CHANGE COLOR OF APARTMENT SELECTED ====
                if (
                    id.includes("sur") === false &&
                    id.includes("Sur") === false &&
                    id.includes("oriente") === false &&
                    id.includes("Oriente") === false &&
                    id.includes("norte") === false &&
                    id.includes("Norte") === false &&
                    id.includes("poniente") === false &&
                    id.includes("Poniente") === false
                ) {
                    if (!unitSelectedId) {
                        setUnitSelectedId(depa);
                        depa.setAttribute("fill", "#FFFFFF");
                        depa.setAttribute("fill-opacity", 0.6);
                    } else if (unitSelectedId && unitSelectedId !== id) {
                        const prevDepa = unitSelectedId;
                        prevDepa.setAttribute("fill", "#00E503");
                        prevDepa.setAttribute("fill-opacity", 0.3);
                        depa.setAttribute("fill", "#FFFFFF");
                        depa.setAttribute("fill-opacity", 0.6);
                        setUnitSelectedId(depa);
                    }
                }
                // ==== SHOW PHOTO AND DATA OF APARTMENT ====
                if (viewSelected?.property_props != null) {
                    viewSelected?.property_props.forEach((element) => {
                        if (element.property_id === id) {
                            setUnitSelected(element);
                            parent.postMessage(element);
                            flag = false;
                        }
                    });
                }

                if (flag) {
                    data.forEach((d) => {
                        if (d.property_props != null) {
                            d.property_props.forEach((property) => {
                                if (property.property_id === id) {
                                    setUnitSelected(property);
                                    parent.postMessage(property);
                                }
                            });
                        }
                    });
                }
            }
        }
    };

    const formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 0,
    });

    return (
        <Flex gap={10} direction={{ base: "column", md: "row" }} px="4vw">
            <Box>
                {isGreaterThanMd && unitSelected ? (
                    <Stack alignItems="start" my="2vh">
                        <Text
                            color={
                                developmentData?.branding_props?.sidebar_accent_text ||
                                developmentData?.branding_props?.accent_text ||
                                "#002B49"
                            }
                            fontSize="3vh"
                            fontWeight={400}
                            fontFamily={
                                developmentData?.branding_props?.brand_font_subtitles ||
                                "Montserrat"
                            }
                        >
                            Departamento:{" "}
                            <strong>
                                {unitSelected?.external_props?.wiggot?.apartment_number}
                            </strong>
                        </Text>
                        <Text
                            color={
                                developmentData?.branding_props?.sidebar_accent_text ||
                                developmentData?.branding_props?.accent_text ||
                                "#002B49"
                            }
                            fontSize="3vh"
                            fontWeight={400}
                            fontFamily={
                                developmentData?.branding_props?.brand_font_subtitles ||
                                "Montserrat"
                            }
                        >
                            Precio:{" "}
                            <strong>
                                {formatter.format(unitSelected?.presale || unitSelected?.sale)} MXN
                            </strong>
                        </Text>
                    </Stack>
                ) : null}
                {!isGreaterThanMd ? (
                    <Stack alignItems="center" my="2vh">
                        <Text
                            color={
                                developmentData?.branding_props?.sidebar_accent_text ||
                                developmentData?.branding_props?.accent_text ||
                                "#002B49"
                            }
                            fontSize="2vh"
                            fontWeight={800}
                            fontFamily={
                                developmentData?.branding_props?.brand_font_subtitles ||
                                "Montserrat"
                            }
                            pt={unitSelected ? "8vh" : "0vh"}
                        >
                            {viewSelected?.name_option || ""}
                        </Text>
                    </Stack>
                ) : null}
                {viewSelected ? (
                    <Box
                        position="relative"
                        width="100%"
                        /*  mb={'70px'} */ mt="30px"
                        mr={{ base: "0", md: "20px" }}
                    >
                        <SVG
                            style={{
                                width: "100%",
                                height: "auto",
                                maxHeight: isGreaterThanMd ? "70vh" : "50vh",
                                minHeight: isGreaterThanMd ? "70vh" : "50vh",
                            }}
                            id="svg"
                            src={viewSelected?.map_image_url}
                            cursor="pointer"
                            onClick={(e) => handleSelect(e)}
                            onLoad={loadSvg}
                        />
                    </Box>
                ) : (
                    <Box
                        position="relative"
                        width="100%"
                        /*  mb={'70px'} */ mt="30px"
                        mr={{ base: "0", md: "20px" }}
                        justifyContent="center"
                    >
                        <Spinner />
                    </Box>
                )}
                <Stack alignItems="center" mt="2vh">
                    <Flex gap={6} direction={{ base: unitSelected ? "row" : "column", md: "row" }}>
                        <Flex gap={3} alignItems="center">
                            <Box
                                bg="#B6C768"
                                w={{ base: unitSelected ? "4vw" : "10vw", md: "2.6vw" }}
                                h="2vh"
                                rounded="md"
                            />
                            <Text
                                color={
                                    developmentData?.branding_props?.sidebar_accent_text ||
                                    developmentData?.branding_props?.accent_text ||
                                    "#002B49"
                                }
                                fontSize={{ base: unitSelected ? "1.2vh" : "2vh", md: "2vh" }}
                                fontWeight={400}
                            >
                                Disponible
                            </Text>
                        </Flex>
                        <Flex gap={3} alignItems="center">
                            <Box
                                bg="#DD4042"
                                w={{ base: unitSelected ? "4vw" : "10vw", md: "2.6vw" }}
                                h="2vh"
                                rounded="md"
                            />
                            <Text
                                color={
                                    developmentData?.branding_props?.sidebar_accent_text ||
                                    developmentData?.branding_props?.accent_text ||
                                    "#002B49"
                                }
                                fontSize={{ base: unitSelected ? "1.2vh" : "2vh", md: "2vh" }}
                                fontWeight={400}
                            >
                                Vendido o en proceso
                            </Text>
                        </Flex>
                        <Flex gap={3} alignItems="center">
                            <Box
                                bg="#F6CC00"
                                w={{ base: unitSelected ? "4vw" : "10vw", md: "2.6vw" }}
                                h="2vh"
                                rounded="md"
                            />
                            <Text
                                color={
                                    developmentData?.branding_props?.sidebar_accent_text ||
                                    developmentData?.branding_props?.accent_text ||
                                    "#002B49"
                                }
                                fontSize={{ base: unitSelected ? "1.2vh" : "2vh", md: "2vh" }}
                                fontWeight={400}
                            >
                                Apartado
                            </Text>
                        </Flex>
                    </Flex>
                    {!unitSelected && (
                        <Box
                            position="absolute"
                            bottom={{ base: "5vh", md: "8vh" }}
                            right={{ base: "5vw", md: "2vw" }}
                            animation="bounce-vertical-availability 0.8s ease-in-out infinite"
                        >
                            <Image
                                minW="5vw"
                                maxW={{ base: "15vw", md: "5vw" }}
                                alt="clic"
                                src={developmentData?.branding_props?.clic}
                            />
                        </Box>
                    )}
                </Stack>
            </Box>
            {!isGreaterThanMd && unitSelected ? (
                <Stack
                    alignItems="center"
                    mt={4}
                    bg={
                        developmentData?.branding_props?.brand_sidebar ||
                        developmentData?.branding_props?.brand ||
                        "#002B49"
                    }
                    rounded="2xl"
                    px={2}
                    py={4}
                    mx="auto"
                    w="85%"
                >
                    <Text
                        color={
                            developmentData?.branding_props?.sidebar_brand_text ||
                            developmentData?.branding_props?.brand_text ||
                            "#FFFFFF"
                        }
                        fontSize="2vh"
                        fontWeight={400}
                        fontFamily={
                            developmentData?.branding_props?.brand_font_subtitles || "Montserrat"
                        }
                    >
                        Departamento{" "}
                        <strong>{unitSelected?.external_props?.wiggot?.apartment_number}</strong>
                    </Text>
                    <Text
                        color={
                            developmentData?.branding_props?.sidebar_brand_text ||
                            developmentData?.branding_props?.brand_text ||
                            "#FFFFFF"
                        }
                        fontSize="2vh"
                        fontWeight={400}
                        fontFamily={
                            developmentData?.branding_props?.brand_font_subtitles || "Montserrat"
                        }
                    >
                        Precio de:{" "}
                        <strong>
                            {formatter.format(unitSelected?.presale || unitSelected?.sale)} MXN
                        </strong>
                    </Text>
                </Stack>
            ) : null}
            {unitSelected && (
                <Flex
                    minW="30vw"
                    maxW={{ base: "100%", md: "30vw" }}
                    justifyItems="center"
                    mt="2vh"
                    direction="column"
                    justifyContent={
                        developmentData?.branding_props?.details_justify || "space-between"
                    }
                    maxH="90vh"
                    overflowY="auto"
                >
                    <Stack>
                        <Text
                            color={
                                developmentData?.branding_props?.sidebar_accent_text ||
                                developmentData?.branding_props?.accent_text ||
                                "#002B49"
                            }
                            fontSize={{ base: "2.2vh", md: "2.4vh" }}
                            fontWeight={700}
                            textTransform="capitalize"
                            textAlign="center"
                            fontFamily={
                                developmentData?.branding_props?.brand_information_font_subtitles ||
                                developmentData?.branding_props?.brand_font_subtitles ||
                                "Montserrat"
                            }
                        >
                            Modelo {unitSelected?.model_name?.toLowerCase()}
                        </Text>
                        <Text
                            color={
                                developmentData?.branding_props?.sidebar_accent_text ||
                                developmentData?.branding_props?.accent_text ||
                                "#002B49"
                            }
                            fontSize={{ base: "2vh", md: "2.4vh" }}
                            fontWeight={400}
                            textTransform="capitalize"
                            textAlign="center"
                            fontFamily={
                                developmentData?.branding_props?.brand_font_subtitles ||
                                "Montserrat"
                            }
                        >
                            Departamento {unitSelected?.external_props?.wiggot?.apartment_number}{" "}
                            &middot; Nivel{" "}
                            {
                                unitSelected?.dimensiones?.filter(
                                    (dim) => dim.dimension_name == "Piso"
                                )[0]?.item_name
                            }
                        </Text>
                        <Text
                            color={
                                developmentData?.branding_props?.sidebar_accent_text ||
                                developmentData?.branding_props?.accent_text ||
                                "#002B49"
                            }
                            fontSize={{ base: "2vh", md: "2.4vh" }}
                            fontWeight={400}
                            textTransform="capitalize"
                            textAlign="center"
                            fontFamily={
                                developmentData?.branding_props?.brand_font_subtitles ||
                                "Montserrat"
                            }
                        >
                            Vista{" "}
                            {
                                unitSelected?.dimensiones?.filter(
                                    (dim) => dim.dimension_name == "Vista"
                                )[0]?.item_name
                            }
                        </Text>
                    </Stack>
                    {developmentData?.branding_props?.details_type == "icons" && (
                        <Flex
                            my="2vh"
                            gap={6}
                            maxW={{ base: "50%", md: "100%" }}
                            wrap="wrap"
                            mx="auto"
                            justifyContent={{ base: "space-between", md: "center" }}
                        >
                            {unitSelected?.external_props?.wiggot?.aparment_surface && (
                                <Flex gap={4} alignItems="center">
                                    <Image
                                        src={
                                            developmentData?.branding_props?.icons_details?.ground
                                                ?.src
                                        }
                                        alt="medidas"
                                        maxW="2vw"
                                        minW={{ base: "7vw", md: "3vw" }}
                                        maxH={{ base: "5vh", md: "3vh" }}
                                        objectFit="contain"
                                    />
                                    <Text
                                        color={
                                            developmentData?.branding_props?.icons_details
                                                ?.brand_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize="1.8vh"
                                        fontWeight={700}
                                        textTransform="capitalize"
                                        textAlign="center"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                    >
                                        {unitSelected?.external_props?.wiggot?.aparment_surface?.toFixed(
                                            2
                                        )}{" "}
                                        m m<sup>2</sup>
                                    </Text>
                                </Flex>
                            )}
                            {unitSelected?.model_features?.bedrooms && (
                                <Flex gap={4} alignItems="center">
                                    <Image
                                        src={
                                            developmentData?.branding_props?.icons_details?.bedrooms
                                                ?.src
                                        }
                                        alt="medidas"
                                        maxW="2vw"
                                        minW={{ base: "7vw", md: "3vw" }}
                                        maxH={{ base: "5vh", md: "3vh" }}
                                        objectFit="contain"
                                    />
                                    <Text
                                        color={
                                            developmentData?.branding_props?.icons_details
                                                ?.brand_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize="1.8vh"
                                        fontWeight={700}
                                        textTransform="capitalize"
                                        textAlign="center"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                    >
                                        {unitSelected?.model_features?.bedrooms}
                                    </Text>
                                </Flex>
                            )}
                            {unitSelected?.model_features?.bathrooms && (
                                <Flex gap={4} alignItems="center">
                                    <Image
                                        src={
                                            developmentData?.branding_props?.icons_details
                                                ?.bathrooms?.src
                                        }
                                        alt="medidas"
                                        maxW="2vw"
                                        minW={{ base: "7vw", md: "3vw" }}
                                        maxH={{ base: "5vh", md: "3vh" }}
                                        objectFit="contain"
                                    />
                                    <Text
                                        color={
                                            developmentData?.branding_props?.icons_details
                                                ?.brand_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize="1.8vh"
                                        fontWeight={700}
                                        textTransform="capitalize"
                                        textAlign="center"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                    >
                                        {unitSelected?.model_features?.bathrooms}
                                    </Text>
                                </Flex>
                            )}
                            {unitSelected?.model_features?.parking_lots && (
                                <Flex gap={4} alignItems="center">
                                    <Image
                                        src={
                                            developmentData?.branding_props?.icons_details?.parking
                                                ?.src
                                        }
                                        alt="medidas"
                                        maxW="2vw"
                                        minW={{ base: "7vw", md: "3vw" }}
                                        maxH={{ base: "5vh", md: "3vh" }}
                                        objectFit="contain"
                                    />
                                    <Text
                                        color={
                                            developmentData?.branding_props?.icons_details
                                                ?.brand_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize="1.8vh"
                                        fontWeight={700}
                                        textTransform="capitalize"
                                        textAlign="center"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                    >
                                        {unitSelected?.model_features?.parking_lots}
                                    </Text>
                                </Flex>
                            )}
                        </Flex>
                    )}
                    <Flex justifyContent="center" my="2vh">
                        <Image
                            src={unitSelected?.render_props}
                            maxW={{ base: "90vw", md: "27vw" }}
                            maxH="50vh"
                            alt="simple icon"
                        />
                    </Flex>
                    <Stack mb={{ base: 14, md: 0 }} alignSelf="center">
                        {developmentData?.branding_props?.details_type == "text" && (
                            <Text
                                color={
                                    developmentData?.branding_props?.sidebar_accent_text ||
                                    developmentData?.branding_props?.accent_text ||
                                    "#002B49"
                                }
                                fontSize={{ base: "1.7vh", md: "2.5vh" }}
                                fontWeight={400}
                                textTransform="capitalize"
                                textAlign="center"
                                pb={4}
                                fontFamily={
                                    developmentData?.branding_props?.brand_font_subtitles ||
                                    "Montserrat"
                                }
                            >
                                {unitSelected?.external_props?.wiggot?.aparment_surface?.toFixed(2)}{" "}
                                m<sup>2</sup>
                            </Text>
                        )}
                        <Flex
                            gap={{ base: 0, md: 4 }}
                            alignItems="center"
                            wrap="wrap"
                            textAlign="center"
                            justifyContent="center"
                            maxW={{ base: "80vw", md: "100%" }}
                            mx="auto"
                        >
                            {developmentData?.branding_props?.details_type == "text" &&
                                unitSelected?.model_features?.bedrooms && (
                                    <Text
                                        color={
                                            developmentData?.branding_props?.sidebar_accent_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize={{ base: "1.4vh", md: "1.7vh" }}
                                        fontWeight={400}
                                        textTransform="capitalize"
                                        textAlign="center"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                        lineHeight={
                                            developmentData?.branding_props?.text?.line_height || ""
                                        }
                                    >
                                        &middot; {unitSelected?.model_features?.bedrooms} Recámaras
                                    </Text>
                                )}
                            {developmentData?.branding_props?.details_type == "text" &&
                                unitSelected?.model_features?.bathrooms && (
                                    <Text
                                        color={
                                            developmentData?.branding_props?.sidebar_accent_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize={{ base: "1.4vh", md: "1.7vh" }}
                                        fontWeight={400}
                                        textTransform="capitalize"
                                        textAlign="center"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                        lineHeight={
                                            developmentData?.branding_props?.text?.line_height || ""
                                        }
                                    >
                                        &middot; {unitSelected?.model_features?.bathrooms} Baños
                                        completos
                                    </Text>
                                )}
                            {developmentData?.branding_props?.details_type == "text" &&
                                unitSelected?.model_features?.parking_lots &&
                                parseInt(unitSelected?.model_features?.parking_lots) > 0 && (
                                    <Text
                                        color={
                                            developmentData?.branding_props?.sidebar_accent_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize={{ base: "1.4vh", md: "1.7vh" }}
                                        fontWeight={400}
                                        textTransform="capitalize"
                                        textAlign="center"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                        lineHeight={
                                            developmentData?.branding_props?.text?.line_height || ""
                                        }
                                    >
                                        &middot; {unitSelected?.model_features?.parking_lots}{" "}
                                        {unitSelected?.model_features?.parking_lots > 1
                                            ? "Cajones de estacionamiento"
                                            : "Cajón de estacionamiento"}
                                    </Text>
                                )}

                            {developmentData?.branding_props?.equipment_text_type == "column" ? (
                                <Flex direction="column" gap="0.5vh" pl={{ base: 0, md: "25%" }}>
                                    {unitSelected?.model_equipment
                                        ?.slice(
                                            0,
                                            unitSelected?.model_equipment?.length > 15
                                                ? 15
                                                : unitSelected?.model_equipment?.length
                                        )
                                        .map((item, index) => (
                                            <Text
                                                color={
                                                    developmentData?.branding_props?.accent_text ||
                                                    "#002B49"
                                                }
                                                fontSize={{ base: "1.4vh", md: "1.5vh" }}
                                                fontWeight={400}
                                                textTransform="capitalize"
                                                textAlign={{ base: "center", md: "left" }}
                                                key={index}
                                                fontFamily={
                                                    developmentData?.branding_props
                                                        ?.brand_font_subtitles || "Montserrat"
                                                }
                                                lineHeight={
                                                    developmentData?.branding_props?.text
                                                        ?.line_height || ""
                                                }
                                            >
                                                &middot; {item}
                                            </Text>
                                        ))}
                                </Flex>
                            ) : (
                                unitSelected?.model_equipment
                                    ?.slice(
                                        0,
                                        unitSelected?.model_equipment?.length > 15
                                            ? 15
                                            : unitSelected?.model_equipment?.length
                                    )
                                    .map((item, index) => (
                                        <Text
                                            color={
                                                developmentData?.branding_props?.accent_text ||
                                                "#002B49"
                                            }
                                            fontSize={{ base: "1.2vh", md: "1.7vh" }}
                                            fontWeight={400}
                                            textTransform="capitalize"
                                            textAlign="center"
                                            key={index}
                                            fontFamily={
                                                developmentData?.branding_props
                                                    ?.brand_font_subtitles || "Montserrat"
                                            }
                                        >
                                            &middot; {item}
                                        </Text>
                                    ))
                            )}
                        </Flex>
                    </Stack>
                </Flex>
            )}
        </Flex>
    );
};

export default ContentSelection;
